import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScoreHelpLinkProps {
  /** Route of the methodology page this score is documented on. */
  to?: string;
  /** Accessible label, e.g. "How the TOSS score is calculated". */
  label?: string;
  className?: string;
}

/**
 * Small "?" affordance that sits next to any public score badge and links to the
 * methodology page explaining how that score is produced.
 */
export const ScoreHelpLink = ({
  to = "/how-toss-works",
  label = "How this score is calculated",
  className,
}: ScoreHelpLinkProps) => (
  <Link
    to={to}
    aria-label={label}
    title={label}
    onClick={e => e.stopPropagation()}
    className={cn(
      "inline-flex items-center justify-center text-muted-foreground hover:text-primary transition-colors align-middle",
      className,
    )}
  >
    <HelpCircle className="w-3.5 h-3.5" aria-hidden="true" />
  </Link>
);

export default ScoreHelpLink;
